import { FunctionComponent, JSX } from 'react'
import styles from './homeCase.module.scss'

interface HomeCaseProps {
    text: string
    icon: JSX.Element
    onClick?: () => void
    href?: string
    isParent?: boolean
    className?: string
}

const HomeCase: FunctionComponent<HomeCaseProps> = ({
    text,
    icon,
    onClick,
    href,
    className,
    isParent = false
}: HomeCaseProps) => {
    return onClick ? (
        <a
            className={`${styles.Case} ${className} ${isParent ? styles.CaseParent : styles.CaseDaycare}`}
            onClick={onClick}
        >
            <p className={styles.CaseTitle}>{text}</p>
            {icon}
        </a>
    ) : href ? (
        <a
            className={`${styles.Case} ${className} ${isParent ? styles.CaseParent : styles.CaseDaycare}`}
            target={'_blank'}
            rel='noreferrer'
            href={href}
        >
            <p className={styles.CaseTitle}>{text}</p>
            {icon}
        </a>
    ) : null
}

export default HomeCase
